<app-navbar class="home" [home_address]="session_info?.last_routes.new_home || '/'"></app-navbar>
<div class="referral-landing-wrapper">
  <div class="container">
    <section class="referral-landing-banner">
      <div class="row pb-5">
        <div class="col-md-7 pb-5">
          <h1 class="display-5">Earn Big with 20% Commission for 1 Year!</h1>
          <p class="display-6">Get ready to effortlessly increase your income through our Referral Program,
            offering a generous <span class="text-secondary fw-bold">20%</span> commission on all sales for
            an
            entire
            year,
            turning your network
            into a
            lucrative income source.
          </p>
          <a class="btn btn-secondary" (click)="getStarted()">
            Get Started
            <i class="bi bi-arrow-right ms-2"></i>
          </a>
          <p class="mt-3 mb-5" *ngIf="!coreService.isLoggedIn()">
            Don’t have an account yet? Click here to <a routerLink="/auth/signup">sign up</a>!
          </p>
        </div>
        <div class="col-md-5 pop-up-form-demo text-end py-5">
          <img loading="lazy" src="assets/landing/Referral.png" width="100%" />
        </div>
      </div>
    </section>
  </div>
</div>

<div class="container">
  <section class="landing-contents">
    <app-shared-how-it-works content="referral"></app-shared-how-it-works>

    <div class="col-md-12 pt-5">
      <div class="row mt-5">
        <div class="col-md-6 text-center">
          <img loading="lazy" src="assets/landing/_referralWhyChooseUs.png" width="529" height="526"
            alt="Why choose our referral program image">
        </div>

        <div class="col-md-6">
          <div class="d-flex flex-column">
            <h3><b>Why Choose Our Referral Program</b></h3>
            <div class="d-flex mt-3">
              <div class="pe-3">
                <img loading="lazy" src="assets/landing/_lucrativeCommission.png" width="25" height="25"
                  alt="Lucrative Commission">
              </div>
              <div>
                <h6><b>Lucrative Commission</b></h6>
                <span class="text-muted">
                  Enjoy a generous 20% commission on every sale made through your referral link.
                  This is one of the highest commission rates you'll find!
                </span>
              </div>
            </div>

            <div class="d-flex mt-3">
              <div class="pe-3">
                <img loading="lazy" src="assets/landing/_passiveIncome.png" width="25" height="25" alt="Passive Income">
              </div>
              <div>
                <h6><b>Passive Income</b></h6>
                <span class="text-muted">
                  Once you've referred a customer, you'll continue to earn commissions on their
                  purchases for one year. Sit back, relax, and watch your earnings grow.
                </span>
              </div>
            </div>

            <div class="d-flex mt-3">
              <div class="pe-3">
                <img loading="lazy" src="assets/landing/_trustedBrand.png" width="25" height="25" alt="Trusted Brand">
              </div>
              <div>
                <h6><b>Trusted Brand</b></h6>
                <span class="text-muted">
                  You'll be promoting products and services from a well-established and trusted
                  brand. Your referrals can shop with confidence.
                </span>
              </div>
            </div>

            <div class="d-flex mt-3">
              <div class="pe-3">
                <img loading="lazy" src="assets/landing/_easyTracking.png" width="25" height="25" alt="Easy Tracking">
              </div>
              <div>
                <h6><b>Easy Tracking</b></h6>
                <span class="text-muted">
                  Our user-friendly dashboard makes it simple to track your referrals,
                  commissions, and earnings. You'll always know how much you've earned.
                </span>
              </div>
            </div>

            <div class="d-flex mt-3">
              <div class="pe-3">
                <img loading="lazy" src="assets/landing/_diverseProductRange.png" width="25" height="25"
                  alt="Diverse Product Range">
              </div>
              <div>
                <h6><b>Diverse Product Range</b></h6>
                <span class="text-muted">
                  We offer a wide range of products and services, catering to various interests
                  and needs. There's something for everyone in your network.
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 pt-5">
      <div class="row mt-5">
        <div class="col-md-6">
          <div class="d-flex flex-column">
            <h3><b>Tips for Success</b></h3>
            <div class="d-flex mt-3">
              <div class="pe-3">
                <img loading="lazy" src="assets/landing/_personalRecommendation.png" width="25" height="25"
                  alt="Personal Recommendations">
              </div>
              <div>
                <h6><b>Personal Recommendations</b></h6>
                <span class="text-muted">
                  Share your personal experiences with our products or services. Authenticity goes
                  a long way in convincing others to give it a try.
                </span>
              </div>
            </div>

            <div class="d-flex mt-3">
              <div class="pe-3">
                <img loading="lazy" src="assets/landing/_leverageSocialMedia.png" width="25" height="25"
                  alt="Leverage Social Media">
              </div>
              <div>
                <h6><b>Leverage Social Media</b></h6>
                <span class="text-muted">
                  Promote your referral link on your social media profiles and relevant groups or
                  forums. Engage with your audience and answer their questions.
                </span>
              </div>
            </div>

            <div class="d-flex mt-3">
              <div class="pe-3">
                <img loading="lazy" src="assets/landing/_emailMarketing.png" width="25" height="25"
                  alt="Email Marketing">
              </div>
              <div>
                <h6><b>Email Marketing</b></h6>
                <span class="text-muted">
                  Utilize your email list to reach out to potential customers. Craft compelling
                  emails highlighting the benefits of our offerings.
                </span>
              </div>
            </div>

            <div class="d-flex mt-3">
              <div class="pe-3">
                <img loading="lazy" src="assets/landing/_consistency.png" width="25" height="25" alt="Consistency">
              </div>
              <div>
                <h6><b>Consistency</b></h6>
                <span class="text-muted">
                  Keep sharing your link and promoting our products consistently. The more you put
                  in, the more you'll get out.
                </span>
              </div>
            </div>

            <div class="d-flex mt-3">
              <div class="pe-3">
                <img loading="lazy" src="assets/landing/_helpAndSupport.png" width="25" height="25"
                  alt="Help and Support">
              </div>
              <div>
                <h6><b>Help and Support</b></h6>
                <span class="text-muted">
                  If you have any questions or need assistance, our dedicated support team is here
                  to help you succeed.
                </span>
              </div>
            </div>

          </div>
        </div>
        <div class="col-md-6 text-center">
          <img loading="lazy" src="assets/landing/_referralTipsForSuccess.png" width="529" height="526"
            alt="Tips for Success">
        </div>
      </div>
    </div>

    <div class="row my-5">
      <div class="col-md-12 text-center pt-5">
        <h1>Join Our Referral Program Today!
        </h1>
        <p>Don't miss out on this incredible opportunity to earn a substantial income with minimal effort. Join
          our Referral Program today and start earning that 20% commission on all sales for the next one year.
          It's a win-win for you and your referrals.</p>
        <a class="btn btn-secondary-light" (click)="getStarted()">
          Get Started
          <i class="bi bi-arrow-right ms-2"></i>
        </a>
      </div>
    </div>
    <app-core-faqs-landing-page [category]="faq_category"></app-core-faqs-landing-page>
    <div class="row mb-5">
      <div class="col-md-12 text-center">
        <h1>Still have questions?</h1>
        <div class="mb-3 fs-3">
          Feel free to reach out to our support team for more information.
          Join our Referral Program today and start earning that 20% commission on all sales for the next one
          year!
        </div>
        <a class="btn btn-secondary-light" routerLink="/contact-us">
          <i class="bi bi-envelope me-2"></i>
          Contact us</a>
      </div>
    </div>
    <br>
    <br>
  </section>
</div>

<app-footer
  footer_text="Ready to get started? Sign up now and take the first step toward financial freedom with our Referral Program!"></app-footer>